<template>
  <div class="ltv-analysis-main-container" v-loading="initLoading">
    <div class="header">
      <div class="left">
        <span class="back" v-if="!!formComponent.boardId" @click="handleBack">
          <icon name="chevron-left" />
        </span>
        <!--<div class="tit">{{ headTitle }}</div>-->
        <t-breadcrumb style="margin-right: 20px">
          <t-breadcrumb-item>{{ headTitle }}</t-breadcrumb-item>
        </t-breadcrumb>
        <div class="mdRemod">
          <img :src="bookHref" style="margin-right: 5px" alt="" />
          <a href="https://docs.qq.com/doc/DV2lwVUhUbnNtWG9U" target="_blank">说明文档</a>
        </div>
      </div>
      <div class="right">
        <t-button variant="outline" @click="handleOpenSave">
          <icon name="save" slot="icon" />
          保存
        </t-button>
      </div>
    </div>

    <my-card>
      <div slot="header" style="display: flex; justify-content: space-between">
        <div class="left">
          <div class="title">分析条件</div>
        </div>
        <div class="right">
          <t-switch size="medium" v-model="showAnalysisConditions"></t-switch>
          <span style="margin-left: 10px">{{ showAnalysisConditions ? '展开' : '收起' }}</span>
        </div>
      </div>

      <div class="content" style="padding-left: 20px" v-show="showAnalysisConditions">
        <div class="panel-row">
          <div class="left">
            <div class="label">起始事件</div>
          </div>
          <div class="right">
            <div style="display: flex">
              <t-select v-model="firstEvent.eventName" placeholder="请选择事件" style="width: 200px">
                <t-option
                  v-for="event in eventSelectOptions"
                  :key="event.eventName"
                  :label="event.eventShowName"
                  :value="event.eventName"
                ></t-option>
              </t-select>
              <t-button variant="outline" style="margin-left: 20px" @click="handleAddFirstEventFilterItem">
                <icon name="add" slot="icon" />
                筛选项
              </t-button>
            </div>
            <div class="filter-container" v-if="firstEvent.conditionModels.length > 0">
              <ConditionFilter
                size="medium"
                :filter-type.sync="firstEvent.connectors"
                :filter-list="firstEvent.conditionModels"
                :condition-operator-options="conditionOperatorOptions"
                :condition-property-options="conditionPropertyOptions"
                :all-event-event-property-list="allEventProperty"
              />
            </div>
          </div>
        </div>
        <div class="panel-row">
          <div class="left">
            <div class="label">营收事件</div>
          </div>
          <div class="right">
            <div style="display: flex">
              <t-select
                v-model="targetEvent.eventName"
                @change="handleTargetEventChange"
                placeholder="请选择事件"
                style="width: 200px"
              >
                <t-option
                  v-for="event in eventSelectOptions"
                  :key="event.eventName"
                  :label="event.eventShowName"
                  :value="event.eventName"
                ></t-option>
              </t-select>

              <EventTargetColumn
                v-model="targetEvent.eventTargetColumn"
                size="small"
                :options="eventTargetColumnOptions"
                style="margin-left: 10px"
              ></EventTargetColumn>

              <t-button variant="outline" style="margin-left: 20px" @click="handleAddTargetEventFilterItem">
                <icon name="add" slot="icon" />
                筛选项
              </t-button>
            </div>
            <div class="filter-container" v-if="targetEvent.conditionModels.length > 0">
              <ConditionFilter
                size="medium"
                :filter-type.sync="targetEvent.connectors"
                :filter-list="targetEvent.conditionModels"
                :condition-operator-options="conditionOperatorOptions"
                :condition-property-options="conditionPropertyOptions"
                :all-event-event-property-list="allEventProperty"
              />
            </div>
          </div>
        </div>

        <div class="panel-row global-filter-cont">
          <div class="left">
            <div class="label">全局筛选</div>
          </div>
          <div class="right">
            <t-button @click="handleAddGlobalFilterItem" variant="outline">
              <icon name="add" slot="icon" />
              筛选项
            </t-button>
            <div class="filter" v-if="form.conditionModels.length">
              <ConditionFilter
                size="medium"
                :filter-type.sync="form.connectors"
                :filter-list="form.conditionModels"
                :condition-operator-options="conditionOperatorOptions"
                :condition-property-options="conditionPropertyOptions"
                :all-event-event-property-list="allEventProperty"
              />
            </div>
          </div>
        </div>

        <div class="panel-row">
          <t-button size="medium" theme="primary" :loading="loadingData" @click="handleGetData" style="width: 80px">
            查询
          </t-button>
          <t-button size="medium" variant="outline" @click="handleReset" style="width: 80px">重置</t-button>
        </div>
      </div>
    </my-card>

    <my-card>
      <div slot="header" style="display: flex; align-items: center; justify-content: space-between">
        <div class="title">分析图表</div>
      </div>
      <div class="section-chart-body" style="position: relative">
        <div class="oper">
          <div class="left" style="">
            <date-range-picker size="medium" v-model="form.dateInfo" @change="onDateInfoChange"></date-range-picker>
            <div class="other">
              <div class="operation-label">展现形式：</div>
              <t-select
                v-model="form.chartShowType"
                placeholder="请选择"
                class="operation-item"
                @change="handleChangeChartShowType"
                style="width: 120px"
              >
                <t-option
                  :label="item.label"
                  :value="item.value"
                  v-for="(item, index) in chartShowTypeOptions"
                  :key="index"
                ></t-option>
              </t-select>
              <template>
                <div class="operation-label" style="margin-left: 12px">LTVn：</div>
                <t-select
                  v-model="form.chartShowDate"
                  placeholder="请选择"
                  class="operation-item"
                  :options="chartShowDateOptions"
                  style="width: 150px"
                />
              </template>
            </div>
          </div>
        </div>
        <div>
          <SectionChart
            v-if="analysisData"
            :analysis-config="analysisConfig"
            :analysis-data="analysisData"
            style="height: 350px"
          ></SectionChart>
          <noData v-else></noData>
        </div>
      </div>
      <t-loading attach=".section-chart-body" v-if="loadingData" size="medium"></t-loading>
    </my-card>

    <my-card>
      <div slot="header" style="display: flex; align-items: center; justify-content: space-between">
        <div class="title">分析列表</div>
        <t-button variant="text" @click="handleExportTableData">导出</t-button>
      </div>
      <div class="section-table-body" style="position: relative">
        <SectionTable
          v-if="analysisData"
          ref="refTableList"
          :analysis-config="analysisConfig"
          :analysis-data="analysisData"
        ></SectionTable>
        <noData v-else></noData>
      </div>
      <t-loading attach=".section-table-body" v-if="loadingData" size="medium"></t-loading>
    </my-card>

    <save
      v-if="dialogSaveVisible"
      key="funnelAnalysisSave"
      :loading="loadingSave"
      :board-info="boardInfo"
      :form-data-component="formComponent"
      :form-data-bookmark="formBookmark"
      @onClose="dialogSaveVisible = false"
      @onSaveComponent="handleSaveComponent"
    ></save>
  </div>
</template>

<script>
import { get, cloneDeep, pick, uniq } from 'lodash';
import dayjs from 'dayjs';
import { Icon } from 'tdesign-icons-vue';
import {
  getEventList,
  getConditionOperator,
  getFunnelDetail,
  getAllProperty,
  getAllEventProperty,
  getTargetColumn,
} from '@/api/analysis/custom-analysis';
import { createComponent, getBoardDetail, getComponentList, modifyComponent } from '@/api/analysis/custom-overview';
import { ltvGetQueryId, ltvPollingData } from '@/api/analysis/new';

import ConditionFilter from '@/components/analysis/condition-filter.vue';
import EventTargetColumn from '@/components/analysis/event-target-column.vue';

// import SelectProps from '@/components/analysis/property-selector.vue';
// import EventAndPropertySelector from '@/components/analysis/event-and-property-selector.vue';

import Save from './components/save.vue';
import DateRangePicker from '@/components/analysis/date-range-picker.vue';
import noData from '@/components/common/no-data-card.vue';
import bookHref from '@/assets/icon/icon-link.svg';

import SectionChart from './components/section-chart.vue';
import SectionTable from './components/section-table.vue';

import { CHART_TYPE } from '@/utils/config';
import { PollingAction } from '@/utils/helper';

import { DEFAULT_CHART_SHOW_TYPE_OPTIONS } from '@/views/analysis/retention-analysis/components/config';

export default {
  name: 'ltv-analysis',
  mixins: [],
  components: {
    Icon,
    noData,
    DateRangePicker,
    ConditionFilter,
    EventTargetColumn,
    SectionChart,
    SectionTable,
    Save,
  },
  data() {
    return {
      bookHref,
      initLoading: false,

      showAnalysisConditions: true,

      firstEvent: {
        eventName: '',
        eventChineseName: '',
        connectors: '',
        conditionModels: [],
      },

      targetEvent: {
        eventName: '',
        eventChineseName: '',
        eventTargetColumn: {
          type: '',
          calcType: '',
        },
        connectors: '',
        conditionModels: [],
      },

      // 前多少项
      showNumLimit: 10,

      /* ------- */
      loadingSave: false,
      dialogSaveVisible: false, // 书签的show

      formBookmark: {
        id: '',
        bookmarkName: '',
        remark: '',
      },
      formComponent: {
        id: '',
        name: '',
        boardId: '',
      },
      boardInfo: {},

      loadingData: false, // 查询的loading
      pa: null,

      eventSelectOptions: [],
      conditionPropertyOptions: [], // 全局筛选用的属性列表
      conditionOperatorOptions: [], // 所有的运算符
      allEventProperty: [],
      eventTargetColumnDataMap: {},

      lastGetDataParams: {},

      analysisData: null,

      form: {
        connectors: 'or',
        conditionModels: [], // 筛选条件
        dateInfo: {
          timeType: 'static',
          timeDimension: null,
          startTime: dayjs().subtract(7, 'day').format('YYYYMMDD'),
          endTime: dayjs().format('YYYYMMDD'),
        },
        chartShowType: 1, // 1-趋势 2-对比
        chartShowDate: -1, // -1 总体趋势，其他日期或时间区间
      },

      chartShowTypeOptions: DEFAULT_CHART_SHOW_TYPE_OPTIONS,
      chartShowDateData: {
        dateOptions: [{ value: -1, label: '总体' }],
        ltvOptions: [],
      },
    };
  },
  computed: {
    headTitle() {
      return this.formComponent.name || this.formBookmark.bookmarkName || 'LTV分析';
    },
    eventTargetColumnOptions() {
      const eventName = this.targetEvent.eventName;
      if (!this.eventTargetColumnDataMap[eventName]) {
        return [{ type: 'totalCount', desc: '总次数' }];
      }
      return this.eventTargetColumnDataMap[eventName];
    },
    chartShowDateOptions() {
      return this.form.chartShowType === 1 ? this.chartShowDateData.dateOptions : this.chartShowDateData.ltvOptions;
    },
    analysisConfig() {
      return {
        chartShowType: this.form.chartShowType,
        chartShowDate: this.form.chartShowDate,
      };
    },
  },
  watch: {
    $route() {
      console.log('main watch $route');
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('routerReload'));
      }, 100);
    },
    eventTargetColumnDataMap: {
      deep: true,
      handler() {
        // console.log('watch eventTargetColumnDataMap', this.eventTargetColumnDataMap);
      },
    },
  },
  mounted() {
    this.initUrlParams();
    this.initData();
  },
  methods: {
    initUrlParams() {
      if (this.$route.query.id || this.$route.query.bookmarkId) {
        this.formBookmark.id = this.$route.query.id || this.$route.query.bookmarkId;
      }
      if (this.$route.query.compId) {
        this.formComponent.id = this.$route.query.compId;
      }
      if (this.$route.query.boardId) {
        this.formComponent.boardId = this.$route.query.boardId;
      }
    },

    async initData() {
      try {
        this.initLoading = true;
        try {
          await this.fetchBaseData();
        } catch (e) {
          this.$message('warning', (e && e.message) || '系统异常，请稍后重试');
        }

        if (this.formBookmark.id) {
          await this.fetchBookmarkData();
          this.handleGetData();
        }
        if (this.formComponent.id) {
          await this.fetchComponentInfo();
          this.handleGetData();
        }
        if (this.formComponent.boardId) {
          await this.fetchBoardInfo();
        }

        await this.getAllConfigEventTargetColumn();
      } catch (e) {
        console.error(e);
      } finally {
        this.initLoading = false;
      }
    },

    async fetchBaseData() {
      // await this.getFunnelLists(true); // 获取漏斗列表

      await Promise.all([
        this.getEventList(),
        this.getAllEventProperty(),
        this.fetchPropertyList(),
        this.getCalculationlist(),
      ]);
    },

    async fetchBookmarkData() {
      try {
        const { id } = this.formBookmark;
        const res = await getFunnelDetail({ params: { id } });

        this.recoverConfig(res);

        this.formBookmark.bookmarkName = res.bookmarkName;
        this.formBookmark.remark = res.remark;
      } catch (e) {
        console.error(e);
      }
    },

    async fetchComponentInfo() {
      try {
        const { id } = this.formComponent;
        const retData = await getComponentList({ params: { id } });
        if (!retData || !retData.length) return;

        Object.assign(this.formComponent, retData[0]);
        const params = this.formComponent.analysisModelDetailVO || {};

        this.recoverConfig(params);
      } catch (e) {
        console.error(e);
      }
    },

    async fetchBoardInfo() {
      try {
        const res = await getBoardDetail({ params: { boardId: this.formComponent.boardId } });
        this.boardInfo = res;
        if (!this.boardInfo.componentList) {
          this.boardInfo.componentList = [];
        }
        if (!this.boardInfo.globalConditionConfigVO) {
          this.boardInfo.globalConditionConfigVO = {};
        }
      } catch (e) {
        console.error(e);
      }
    },

    recoverConfig(res) {
      // this.fixConditionModels(res.conditionModels);
      // this.fixConditionModels(res.firstEvent.conditionModels);
      // this.fixConditionModels(res.targetEvent.conditionModels);

      this.form = {
        connectors: res.connectors,
        conditionModels: res.conditionModels,
        dateInfo: res.dateInfo,
        chartShowType: res.chartShowType,
        chartShowDate: Number(res.chartShowDate),
      };
      this.firstEvent = res.firstEvent;
      this.targetEvent = res.targetEvent;
    },

    fixConditionModels(conditionList = []) {
      conditionList.forEach(item => {
        if (!(item.value === undefined || item.value === null)) {
          if (!Array.isArray(item.value)) {
            if (item.value.includes(',')) {
              item.value = item.value.split(',');
            } else {
              item.value = [item.value];
            }
          }
        }
      });
    },

    handleReset() {
      const data = {
        connectors: 'or',
        conditionModels: [], // 筛选条件
        dateInfo: {
          timeType: 'static',
          timeDimension: null,
          startTime: dayjs().subtract(7, 'day').format('YYYYMMDD'),
          endTime: dayjs().format('YYYYMMDD'),
        },
        chartShowType: 1,
        chartShowDate: -1,
      };
      this.form = { ...this.form, ...data };

      this.firstEvent.eventName = '';
      this.firstEvent.connectors = '';
      this.firstEvent.conditionModels = [];

      this.targetEvent.eventName = '';
      this.targetEvent.connectors = '';
      this.targetEvent.conditionModels = [];

      this.getAllConfigEventTargetColumn();
    },

    handleAddFirstEventFilterItem() {
      if (this.firstEvent.conditionModels.length >= 5) {
        this.$message('warning', '最多添加5个筛选项');
        return;
      }
      this.addFilterItem(this.firstEvent.conditionModels, this.conditionPropertyOptions);
    },

    handleAddTargetEventFilterItem() {
      if (this.targetEvent.conditionModels.length >= 5) {
        this.$message('warning', '最多添加5个筛选项');
        return;
      }
      this.addFilterItem(this.targetEvent.conditionModels, this.conditionPropertyOptions);
    },

    handleAddGlobalFilterItem() {
      if (this.form.conditionModels.length >= 5) {
        this.$message('warning', '最多添加5个筛选项');
        return;
      }
      this.addFilterItem(this.form.conditionModels, this.conditionPropertyOptions);
    },

    addFilterItem(list, propList) {
      const item = { column: '', conditionOperator: '', value: undefined };
      const nPropList = propList.filter(i => i.propertyType === 1); // 只取事件属性
      if (nPropList.length) {
        const tmpPropertyItem = nPropList[0];
        item.column = tmpPropertyItem.propertyName;
        // eslint-disable-next-line max-len
        const tmpOperatorArr = this.conditionOperatorOptions.filter(
          i => i.javaType === tmpPropertyItem.propertyDataType,
        );
        if (tmpOperatorArr.length) {
          item.conditionOperator = tmpOperatorArr[0].type;
        }
      }
      list.push(item);
    },

    async handleTargetEventChange() {
      if (this.targetEvent.eventName) {
        const findEvent = this.eventSelectOptions.find(item => item.eventName === this.targetEvent.eventName);
        // console.log('findEvent', findEvent);
        this.targetEvent.eventChineseName = findEvent ? findEvent.eventShowName : '未知事件';
        this.targetEvent.eventTargetColumn = {
          type: '',
          calcType: '',
        };
        await this.getEventTargetColumn(this.targetEvent.eventName);
      }
    },

    async getAllConfigEventTargetColumn() {
      const events = [];
      if (this.firstEvent.eventName) {
        events.push(this.firstEvent.eventName);
      }
      if (this.targetEvent.eventName) {
        events.push(this.targetEvent.eventName);
      }
      await this.getEventTargetColumn(events.join(','));
    },

    async getEventTargetColumn(events) {
      if (!events) return;
      const narr = [];
      const arr = events.split(',');
      arr.forEach(en => {
        if (!this.eventTargetColumnDataMap[en]) {
          narr.push(en);
        }
      });
      if (narr.length <= 0) return;
      const retData = await getTargetColumn({ params: { events: narr.join(',') } });
      Object.keys(retData).forEach(key => {
        if (Object.prototype.hasOwnProperty.call(retData, key)) {
          this.$set(this.eventTargetColumnDataMap, key, retData[key]);
        }
      });
    },

    async handleSaveComponent(type, form) {
      const analysisModelReq = this.buildParams();

      console.log('analysisModelReq', JSON.stringify(analysisModelReq, null, 2));

      const params = {
        analysisType: 'ltv',
        analysisModelReq: JSON.stringify(analysisModelReq),
      };

      const propArr = ['id', 'name', 'boardId', 'chartType', 'size', 'remark', 'ext'];
      if (form.chartType === CHART_TYPE.NUMBER_TYPE) {
        // 漏斗分析暂时不会有数值型卡片，不过因为从事件分析拷贝过来的，先保留了
        propArr.push('primaryIndex');
        propArr.push('secondaryIndex');
      } else if (form.chartType === CHART_TYPE.TABLE) {
        //
      } else if (form.chartType === CHART_TYPE.CHART_LINE) {
        propArr.push('lineCount');
      }

      const tmpObj = pick(form, propArr);
      Object.assign(params, tmpObj);

      console.log('handleSaveComponent params', params);

      // eslint-disable-next-line no-unused-vars
      let retData;
      try {
        this.loadingSave = true;
        if (type === 'new') {
          await createComponent({ data: params });
        } else {
          await modifyComponent({ data: params });
        }

        this.$message('success', '保存成功');
        this.dialogSaveVisible = false;

        setTimeout(() => {
          this.$router.replace({
            name: 'OverviewHome',
            query: {
              boardId: params.boardId,
            },
          });
        }, 100);
      } finally {
        this.loadingSave = false;
      }
    },

    async handleOpenSave() {
      const validRet = this.validConfig();
      if (!validRet) {
        return;
      }
      this.dialogSaveVisible = true;
    },

    async getEventList() {
      const res = await getEventList();
      this.eventSelectOptions = res;
    },

    // 获取所有的运算符
    async getCalculationlist() {
      const res = await getConditionOperator();
      this.conditionOperatorOptions = res;
    },

    async getAllEventProperty() {
      const res = (await getAllEventProperty({})) || [];
      this.allEventProperty = res.map(item => ({
        eventName: item.eventName,
        eventShowName: item.eventShowName,
        propertyList: (item.propertyList || []).map(i => ({
          propertyName: i.name,
          propertyDesc: i.chineseName,
          propertyType: i.propertyType,
          propertyDataType: i.javaType,
        })),
      }));
    },

    async fetchPropertyList() {
      // 这里要注意，node层转发的时候，默认加了 hasData=1，所以这里加不加hasData没有实际影响
      const res = await getAllProperty({ params: { hasData: 1, isVisible: 1 } });
      const arr = [];
      res.list.forEach(itm => {
        const obj = {
          propertyName: itm.name,
          propertyDesc: itm.chineseName,
          propertyType: itm.propertyType,
          propertyDataType: itm.javaType,
          name: itm.name,
          propertyValueTipVOList: itm.propertyValueTipVOList,
        };
        arr.push(obj);
      });
      this.conditionPropertyOptions = arr;
    },

    buildParams() {
      const data = cloneDeep(this.form);

      data.conditionModels.forEach((res, idx) => {
        if (res.value === undefined) {
          data.conditionModels[idx].value = '';
        }
        if (Array.isArray(res.value)) {
          data.conditionModels[idx].value = data.conditionModels[idx].value.join(',');
        }
      });

      data.firstEvent = cloneDeep(this.firstEvent);
      data.targetEvent = cloneDeep(this.targetEvent);

      data.firstEvent.conditionModels.forEach(res => {
        if (res.value === undefined) {
          res.value = '';
        }
        if (Array.isArray(res.value)) {
          res.value = res.value.join(',');
        }
      });

      data.targetEvent.conditionModels.forEach(res => {
        if (res.value === undefined) {
          res.value = '';
        }
        if (Array.isArray(res.value)) {
          res.value = res.value.join(',');
        }
      });

      return data;
    },

    validConfig() {
      const data = this.buildParams();

      // 检查事件配置
      let errMsg = '';

      if (!this.firstEvent.eventName) {
        errMsg = '请选择起始事件';
      } else if (!this.targetEvent.eventName) {
        errMsg = '请选择营收事件';
      } else if (!this.targetEvent.eventTargetColumn.type) {
        errMsg = '请选择营收事件的统计指标';
      }

      if (errMsg) {
        this.$message('warning', errMsg);
        return false;
      }

      let emptyFlag = false;
      data.conditionModels.forEach(res => {
        if (!res.column || !res.conditionOperator) {
          emptyFlag = true;
        }
      });
      if (emptyFlag) {
        this.$message('warning', '全局筛选条件请填写完整');
        return false;
      }
      return true;
    },

    async handleGetData() {
      const validRet = this.validConfig();
      if (!validRet) {
        return;
      }
      const data = this.buildParams();
      this.lastGetDataParams = data;
      console.log('this.lastGetDataParams', JSON.stringify(this.lastGetDataParams, null, 4));

      try {
        this.loadingData = true;
        const uuid = await ltvGetQueryId({ data });

        let retData;
        this.pa = new PollingAction({
          delay: 2000,
          handler: async () => {
            retData = await ltvPollingData({ params: { uuid } });
            if (!retData) {
              return true;
            }
            return false;
          },
        });
        await this.pa.start();
        if (!retData) {
          throw new Error('retData is null');
        }

        // const retData = resultJson;

        this.setAnalysisData(retData);

        this.loadingData = false;
      } catch (e) {
        console.error('handleGetData error', e);
        this.loadingData = false;
      }
    },

    setAnalysisData(retData) {
      this.chartShowDateData.dateOptions = [
        { value: -1, label: '总体' },
        ...retData.dateList.map((d, i) => ({ value: i, label: d })),
      ];
      this.chartShowDateData.ltvOptions = [...retData.ltvList.map((d, i) => ({ value: i, label: d }))];

      this.analysisData = retData;
    },

    handleExportTableData() {
      if (!this.analysisData) {
        return;
      }
      this.$refs.refTableList.exportData();
    },

    handleChangeChartShowType() {
      if (this.form.chartShowType === 1) {
        this.form.chartShowDate = -1; // 总体趋势
      } else {
        this.form.chartShowDate = 0; // 第0个日期
      }
    },

    onDateInfoChange(data) {
      if (this.getD(dayjs(data[0]).format('YYYY/MM/DD'), dayjs(data[1]).format('YYYY/MM/DD'))) {
        this.$message.error('选择的时间区间不可大于31天');
        this.form.dateInfo = {
          timeType: 'static',
          timeDimension: null,
          startTime: dayjs().subtract(7, 'day').format('YYYYMMDD'),
          endTime: dayjs().format('YYYYMMDD'),
        };
      }
    },

    getD(starDate, endDate) {
      const sDate = new Date(starDate).getTime();
      const eDate = new Date(endDate).getTime();
      const thisMothDays = 1000 * 3600 * 24 * 31;
      if (eDate - sDate > thisMothDays) {
        return true;
      }
      return false;
    },

    handleBack() {
      this.$router.replace({
        name: 'OverviewHome',
        query: {
          boardId: this.formComponent.boardId,
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
@import './ltv-analysis.less';
</style>

<style lang="less">
.ltv-analysis-main-container {
  .form-box {
    .form-config {
      .el-form-item__label {
        color: #888888;
      }
    }
  }
}

.popover-ltv-analysis-select-funnel {
  max-height: inherit;

  > div {
    max-height: 300px;
    overflow-y: auto;

    &::-webkit-scrollbar-thumb {
      background-color: rgb(204, 204, 204);
    }
    &::-webkit-scrollbar {
      width: 6px;
      background-color: #f5f5f5;
    }
  }

  .t-select__groups {
    //position: relative;
    .btn-new-funnel {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }

  .list-item {
    .operate {
      padding-left: 5px;
      float: right;
      visibility: hidden;
    }
    &:hover {
      .operate {
        visibility: visible;
      }
    }
  }
}
</style>
